export default {
  na: 'notAssigned',
  Tag1: 'tag1',
  Tag2: 'tag2',
  TagA: 'tagA',
  TagB: 'tagB',
  TagC: 'tagC',
  TagD: 'tagD',
  TagE: 'tagE',
  BinLocation: 'binLocation',
  Barcode1: 'barcode',
  Barcode2: 'barcode2',
  Barcode3: 'barcode3',
  ProductCategory: 'productCategory',
  LocationBarcode: 'locationBarcode',
  ProductAccountNumber: 'productAccountNumber',
}
